import React from 'react'
import { FiAperture } from '@react-icons/all-files/fi/FiAperture'
import { FiDisc } from '@react-icons/all-files/fi/FiDisc'
import { FiGrid } from '@react-icons/all-files/fi/FiGrid'
import { FiLayers } from '@react-icons/all-files/fi/FiLayers'
import { FiVolume2 } from '@react-icons/all-files/fi/FiVolume2'
import { FiZap } from '@react-icons/all-files/fi/FiZap'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import styles from './ServiceCategoryGrid.module.scss'

const categories = [
  {
    key: 'sound',
    name: 'Sound Systems',
    description: 'Speakers, microphones, mixers, and managed audio systems.',
    href: '/sound-system-rental',
    icon: FiVolume2
  },
  {
    key: 'visuals',
    name: 'Visuals',
    description: 'LED video walls, projectors, screens, and commercial displays.',
    href: '/visuals',
    icon: FiGrid
  },
  {
    key: 'staging',
    name: 'Staging',
    description: 'Stage decks, risers, truss, and pipe-and-drape systems.',
    href: '/stage-rental',
    icon: FiLayers
  },
  {
    key: 'lighting',
    name: 'Lighting',
    description: 'Stage lighting, uplighting, moving heads, and spotlights.',
    href: '/lighting-rental',
    icon: FiZap
  },
  {
    key: 'dj_equipment',
    name: 'DJ Equipment',
    description: 'Professional mixers, controllers, CDJs, and playback systems.',
    href: '/dj-equipment-rental',
    icon: FiDisc
  },
  {
    key: 'special_effects',
    name: 'Special Effects',
    description: 'Cold sparks, CO₂ effects, fog, and event atmosphere.',
    href: '/special-effects',
    icon: FiAperture
  }
]

const orlandoCategoryRoutes = {
  sound: '/orlando/speaker-rental',
  visuals: '/orlando/led-video-wall-rental',
  staging: '/orlando/stage-rental',
  dj_equipment: '/orlando/dj-equipment-rental'
}

const ServiceCategoryGrid = ({
  currentCategory = 'sound',
  orlando = false,
  eyebrow = 'Complete event support',
  heading = 'Explore other AV categories',
  description = 'Build beyond sound with equipment and production services coordinated by the same local team.'
}) => (
  <section className={styles.section} aria-labelledby='av-category-title'>
    <Container>
      <div className={styles.heading}>
        <div>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h2 id='av-category-title'>{heading}</h2>
        </div>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.grid}>
        {categories.map(category => {
          const Icon = category.icon
          const isCurrent = category.key === currentCategory
          const href = orlando
            ? orlandoCategoryRoutes[category.key] || category.href
            : category.href
          return (
            <Action
              href={href}
              key={category.name}
              variant='plain'
              wrapContent={false}
              className={`${styles.card} ${isCurrent ? styles.current : ''}`}
              ariaCurrent={isCurrent ? 'page' : undefined}
            >
              <span className={styles.icon}><Icon aria-hidden='true' /></span>
              <span className={styles.copy}>
                <strong>{category.name}</strong>
                <small>{category.description}</small>
              </span>
              <span className={styles.arrow} aria-hidden='true'>→</span>
            </Action>
          )
        })}
      </div>
    </Container>
  </section>
)

export default ServiceCategoryGrid
